module.exports = __webpack_public_path__ + "static/antd-skeleton-animated-eef2473a02a6cc12e82c29eaabf6aa7f.gif";